import { ModalLista } from "./ModalLista";

interface ModalListaProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  data: {
    codigo: string;
    descricao: string;
    porcentagem: number;
    tipos?: string;
  }[];
}

export function ModalAcabMaisCalculados({
  isOpen,
  onClose,
  title,
  data,
}: ModalListaProps) {
  return (
    <ModalLista
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      columns={[
        {
          field: "codigo",
          headerName: "Código",
          sortable: false,
          flex: 0.3,
        },
        {
          field: "descricao",
          headerName: "Descrição",
          sortable: false,
          flex: 0.3,
        },
        {
          field: "porcentagem",
          headerName: "Porcentagem",
          sortable: false,
          flex: 0.3,
        },
        {
          field: "tipos",
          headerName: "Tipos de acabementos",
          sortable: false,
          flex: 0.3,
        },
      ]}
      rows={data.map((d, index) => {
        return {
          ...d,
          id: index + 1,
        };
      })}
    />
  );
}
